import { createSelector } from "reselect";
import { Organization } from "../../../@types/organization";
import { RootState } from "../../rootReducer";

const getOrganizations = (organizations: Organization[], parent?: Organization): Organization[] =>
  organizations
    .map((organization) => ({
      ...organization,
    }));

export const selectOrganizations = createSelector(
  [(store: RootState) => store.organizations.organizations],
  (data) => data // getOrganizations(data)
);
